import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { CommonDataService } from '../../../common/services/common-data.service';
import { GraphqlService } from '../../../common/services/graphql.service';
import { LoginService } from '../../../common/services/Login.service';
import { SessionService } from '../../../common/services/Session.service';
@Component({
  selector: 'app-help-pendingcontent',
  templateUrl: './help-pendingcontent.component.html'
})
export class HelpPendingcontentComponent implements OnInit {

  constructor(public commonDataService: CommonDataService,
    private graphQlService: GraphqlService, private sanitize: DomSanitizer, private route: Router, private session: SessionService, private loginService: LoginService) {
  }
  outcome: boolean= false;
  pd_heading;
  pd_desc;
  pd_para1heading;
  pd_para1body;
  pd_para2heading_1_desc;
  pd_para2heading_1;
  binary_image;
  pd_para1_2;
  pd_para1;
  imageURL;
  pcs_BodyDesc;
  pcs_BodyPreDesc;
  pcs_heading;
  pcs_BodyPreDesc2;
  content1TC;
  content2TC; content3TC;
  userSession: any[];
  Isnotloginpage = true;
  // IsRightPanel: boolean;
  role: any;
  userId: any;

  @Input() IsRightPanel: boolean = false;
  @Output() myEvent = new EventEmitter<string>();
  ngOnInit(): void {

    // this.IsRightPanel = this.commonDataService.showRightPanel.getValue();
    if (this.session.userInfo == undefined || this.session.userInfo.user == null) {
      this.loginService.getSession().subscribe(data => {
        this.userId = data.user.firstname + " " + data.user.lastname;
        this.role = data.user.roles;
        this.session.assignUserInfo(data.user);
      })
    }
    else {
      this.userId = this.session.userInfo.user.firstname + " " + this.session.userInfo.user.lastname;
      this.role = this.session.userInfo.user.roles;
    }
    if (this.route.url == '/Login') {
      this.Isnotloginpage = false;
    }
    window.scrollTo(0, 0);

    this.commonDataService.showLoader.next(true);
    this.gethelppendingcontentlabels();
  }
  pcs_decline;
  pcs_agree;
  gethelppendingcontentlabels() {

    this.graphQlService.gethelppendingcontentLabels().subscribe(data => {
      if (data != "") {
        var labels = data.result.content.data.labels;
        labels = labels.filter(x => x.key.trim());
        this.pd_heading = labels.filter(x => x.key == "pd_heading").map(y => y.value);
        this.pd_para1 = labels.filter(x => x.key == "pd_para1").map(y => y.value);
        this.pd_para1_2 = labels.filter(x => x.key == "pd_para1_2").map(y => y.value);
        this.pd_para2heading_1 = labels.filter(x => x.key == "pd_para2heading_1").map(y => y.value);
        this.pd_para2heading_1_desc = labels.filter(x => x.key == "pd_para2heading_1_desc").map(y => y.value);
        this.pcs_BodyDesc = labels.filter(x => x.key == "pcs_BodyDesc").map(y => y.value);
        this.pcs_BodyPreDesc = labels.filter(x => x.key == "pcs_BodyPreDesc").map(y => y.value);
        this.pcs_heading = labels.filter(x => x.key == "pcs_heading").map(y => y.value);
        this.pcs_decline = labels.filter(x => x.key == "pcs_decline").map(y => y.value);
        this.pcs_agree = labels.filter(x => x.key == "pcs_agree").map(y => y.value);
        this.pcs_BodyPreDesc2 = labels.filter(x => x.key == "pcs_BodyPreDesc2").map(y => y.value);
        this.content1TC = this.pcs_BodyPreDesc2[0]?.split("[Terms_And_Condition]")[0]
        this.content2TC = "Terms And Conditions"
        this.content3TC = this.sanitize.bypassSecurityTrustHtml(this.pcs_BodyPreDesc2[0]?.split("[Terms_And_Condition]")[1]);
      //  this.binary_image = labels.filter(x => x.key == "pd_imageid").map(y => y.value);
        this.imageURL = data.url;
        this.outcome = true;
        this.commonDataService.showLoader.next(false);
      }
    }, err => {
      console.log(err);
      this.commonDataService.showLoader.next(false);
    });
  }
  homepageredirect() {
    this.route.navigateByUrl("/Home");
  }
  acceptTC() {
    this.myEvent.emit();
    this.route.navigate(['pendingcontentsystemagreement']);
    //this.graphQlService.SetPendingContentAgreementSession(true).subscribe(data => {
    //  this.route.navigate(['pendingcontentsystem']);
    //}, err => {
    //  console.log(err);
    //  this.commonDataService.showLoader.next(false);
    //});
  }
  showTC() {
    this.commonDataService.showRightPanel.next(true);
    this.commonDataService.rightOverlayOption.next("Terms And Conditions");
    this.commonDataService.rightPanelWidth.next("rightOverlay_large");
    this.commonDataService.tcsource.next("pendingcontentsystem");
    this.commonDataService.closeModalOption.next(true);
  }
  openLinkbyId(event) {
    let id = event.target.id;
    if (id != "") {
      if (this.route.url == '/Login') {
        this.commonDataService.NavigatingFromComponent.next("helppcs");
        this.commonDataService.childComponent.next(true);
        this.commonDataService.rightPanelWidth.next("rightOverlay_large");
        this.commonDataService.showRightPanel.next(true);
        this.commonDataService.rightOverlayOption.next(id);
      } else if (id == "pcsfaq" && this.IsRightPanel) {
        this.commonDataService.rightOverlayOption.next(id);
        this.commonDataService.NavigatingFromComponent.next("helppendingcontent");
        this.commonDataService.childComponent.next(true);
      }
      else {
        this.myEvent.emit();
        this.route.navigate([event.target.id]);
      }
    }
  }

}
